<template>
  <v-container fluid>

  <div class="headline text-xs-left">
    Site Setup
  </div>

  <LearnItem>
    <template slot="title">How do I change my store URL? </template>
    Your store URL is where buyers will find your store. You can change
    it on your <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link> page.
   </LearnItem>
   <LearnItem>
     <template slot="title">How do I change the colors on my site?</template>
     SmartKidsMarket has different colors sets you can use to personalize your
     site. On the <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link> page
     by selecting a different color scheme the colors for your site will change immediately.
     <br /><br />Try them out by changing colors and then looking at your site to find the
     ones you want. If you want a color scheme that isn't there,
     <a href="mailto:dan@smartkidsmarket.com">let us know</a> what you want
     and we can add it!
  </LearnItem>

  <LearnItem>
    <template slot="title">Adding social media links</template>
    If you have Social Media accounts you want to link to from your SmartKidsMarket store
    you can do that. Add them from the <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link>
    page. You can add links to Facebook, Instagram, Twitter, YouTube, Pinterest, and Vimeo.
    <br /><br />Did we miss one? <a href="mailto:dan@smartkidsmarket.com">Let us know</a> what you want
    and we can add it!
  </LearnItem>

  </v-container>

</template>

<script>

import LearnItem from './LearnItem.vue'

export default {
  components: {
    LearnItem
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

</style>
